















































import { Component, Vue } from 'vue-property-decorator'
import * as SmoothScroll from '@/assets/scripts/NewSmoothScrollModule'


@Component
export default class LocomotiveSmoothscroll extends Vue {

	data() {
		return {
			PageTitle: "Locomotive Smooth scroll"
		}
	}
	mounted() {
		new SmoothScroll.smoothScrollModule()
	}
}
